const defaultEndpoint = '/stories'

const state = {
  storiesList: {},
  storiesNextPageLink: null,
  storiesFiltersApplied: null,
  storiesListScrollIndex: 0,
  shallFetch: true,
  shallRefreshCounter: 0,
  currentPreviewUsername: null,
  notificationStoryId: null,
  notificationStoryData: null,
}

const getters = {
  shallFetch: (state) => {
    return state.shallFetch
  },

  shallRefreshCounter: (state) => {
    return state.shallRefreshCounter
  },

  storiesListScrollIndex: (state) => {
    return state.storiesListScrollIndex
  },

  storiesList: (state) => {
    return state.storiesList ? state.storiesList : null
  },

  storiesNextPageLink: (state) => {
    return state.storiesNextPageLink ? state.storiesNextPageLink : null
  },

  storiesFiltersApplied: (state) => {
    return state.storiesFiltersApplied ? state.storiesFiltersApplied : null
  },

  currentPreviewUsername: (state) => {
    return state.currentPreviewUsername
  },

  notificationStoryId: (state) => {
    return state.notificationStoryId
  },

  notificationStoryData: (state) => {
    return state.notificationStoryData
  },
}

const actions = {
  async fetchStories({ commit }, data) {
    let { payload } = data
    let endpoint = `${defaultEndpoint}`

    return await this._vm.$api
      .get(endpoint, { params: payload })
      .catch((error) => {
        return { data: null }
      })
  },

  async fetchStoryUsers({ commit }, data) {
    let { payload } = data
    let endpoint = `${defaultEndpoint}/story-users`

    return await this._vm.$api
      .get(endpoint, { params: payload })
      .catch((error) => {
        return { data: null }
      })
  },

  async fetchStory({ commit }, data) {
    let { payload, id } = data
    let endpoint = `${defaultEndpoint}/${id}`

    let response = await this._vm.$api
      .get(endpoint, { params: payload })
      .catch((error) => {
        return { data: null }
      })

    if (response.data == null || response.data.data == null) {
      commit('setStory', { data: null, id })
      return response
    }

    commit('setStory', { data: response.data.data, id })
    return response
  },

  async createStory({ dispatch, commit }, form) {
    return form.post(defaultEndpoint)
  },

  async updateStory({ dispatch, commit }, form) {
    return form.post(`${defaultEndpoint}/${form.id}`)
  },

  async createPresignedUploadURL({ dispatch, commit }, form) {
    let endpoint = `${defaultEndpoint}/presigned-upload-url`

    return await form.post(endpoint)
  },

  async deleteStory({ dispatch, commit }, form) {
    let { id } = form
    await form.delete(`${defaultEndpoint}/${id}`)

    let response = form._response

    if (!form.errors.any() && response) {
      commit('setStory', { data: null, id })
      commit('setStoryInList', { data: null, id })
    }

    return response
  },

  async markStoryAsViewed({ dispatch, commit }, storyId) {
    try {
      const response = await this._vm.$api.post(`${defaultEndpoint}/${storyId}/view`)
      return response
    } catch (error) {
      console.error('Error marking story as viewed:', error)
      return { data: null }
    }
  },

  async fetchStoryViewers({ dispatch, commit }, storyId) {
    try {
      const response = await this._vm.$api.get(`${defaultEndpoint}/${storyId}/viewers`)
      return response
    } catch (error) {
      console.error('Error fetching story viewers:', error)
      return { data: null }
    }
  },

  async makeStoryReaction({ dispatch, commit }, storyId) {
    try {
      const response = await this._vm.$api.post(`${defaultEndpoint}/${storyId}/make-reaction`)
      return response
    } catch (error) {
      console.error('Error making story reaction:', error)
      return { data: null }
    }
  },
}

const mutations = {
  setStoriesList(state, data) {
    state.storiesList = !_.isEmpty(data) ? {...data} : null

    if (data == null) {
      state.storiesNextPageLink = null
      state.storiesFiltersApplied = null
    }
  },

  setStoryInList(state, payload) {
    let { data, id } = payload

    if (_.isEmpty(state.storiesList)) {
      return null
    }

    let stories = {...state.storiesList}

    if (data) {
      // Update or add the item to the object using its ID as the key
      stories[id] = data
      state.storiesList = stories
    } else {
      // Remove the item from the object
      delete stories[id]
      state.storiesList = stories
    }
  },

  setStory(state, payload) {
    let { data, id } = payload

    if (data == null) {
      if (!_.isEmpty(state.storiesList[id])) {
        delete state.storiesList[id]
      }
      return
    }

    let stories = { ...state.storiesList }
    stories[id] = { ...data }
    state.storiesList = stories
  },

  setStoriesListScrollIndex(state, index) {
    state.storiesListScrollIndex = index
  },

  setStoriesNextPageLink(state, data) {
    state.storiesNextPageLink = data
  },

  setStoriesFiltersApplied(state, data) {
    state.storiesFiltersApplied = data
  },

  setShallFetch(state, value) {
    state.shallFetch = value
  },

  setShallRefreshCounter(state, value) {
    state.shallRefreshCounter = value
  },

  incrementShallRefreshCounter(state) {
    state.shallRefreshCounter++
  },

  setCurrentPreviewUsername(state, username) {
    state.currentPreviewUsername = username
  },

  setNotificationStoryId(state, storyId) {
    state.notificationStoryId = storyId
  },

  setNotificationStoryData(state, storyData) {
    state.notificationStoryData = storyData
  },

  clearNotificationStory(state) {
    state.notificationStoryId = null
    state.notificationStoryData = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
